import { render, staticRenderFns } from "./StatsDataPanel.vue?vue&type=template&id=285c457e&scoped=true&"
import script from "./StatsDataPanel.vue?vue&type=script&lang=js&"
export * from "./StatsDataPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c457e",
  null
  
)

export default component.exports